module.exports = __webpack_public_path__ + "img/recipe.f15ec19d.png";